module.exports = __webpack_public_path__ + "img/frame (286).c6fdc573.jpg";